
import { Vue, Component } from 'vue-property-decorator';
import { review, record } from '../api';
import { Field, Toast } from 'vant';
Vue.use(Field);

@Component({})
export default class Home extends Vue {
  total: string = '';
  wrong: string = '';
  async mounted() {
    if (!localStorage.getItem('0420BMB_token')) {
      this.$router.push('login');
    }
    const data1 = {
      name: 'total',
    };
    const res: any = await record(data1);

    this.total = res[0].value;

    const data2 = {
      name: 'wrong',
    };
    const ret: any = await record(data2);
    this.wrong = ret[0].value;
  }
  async submit() {
    if (!this.total) {
      Toast.fail('请填写审读数！');
      return false;
    } else if (!this.wrong) {
      Toast.fail('请填写差错数！');
      return false;
    } else {
      const data = {
        token: localStorage.getItem('0420BMB_token'),
        total: this.total,
        wrong: this.wrong,
      };
      const res: any = await review(data);

      if (res.statusCode === 200) {
        Toast.success('提交成功！');
        setTimeout(() => {
          location.reload();
        }, 1500);
      } else if (res.statusCode === 401) {
        Toast.fail(res.message);
        setTimeout(() => {
          this.$router.push('login');
        }, 1500);
      } else {
        Toast.fail(res.message);
      }
    }
  }
}
